import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { Input, InputProps, Text } from "@ui-kitten/components";
import Button from "components/Button";
import LoginContainer from "components/LoginContainer";
import { AUTH_SCREEN_BUTTON_BACKGROUND } from "constants/";
import { login } from "features/slices/authSlice";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import i18n from "plugins/localization";
import React, { useRef, useState } from "react";
import { Platform, Pressable, View } from "react-native";

export const emailIcon = () => (
  <MaterialIcons name="email" size={24} color="white" />
);
export const lockIcon = () => (
  <MaterialIcons name="lock" size={24} color="white" />
);

export const loginInputProps: InputProps = {
  placeholderTextColor: "white",
  style: {
    borderRadius: 0,
    backgroundColor: "transparent",
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderColor: "white",
  },
  textStyle: { color: "white" },
  autoCapitalize: "none",
  autoCorrect: false,
};

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const ref_password = useRef<any>(null);
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.auth);

  const navigation = useNavigation();

  const handleLogin = async () => {
    await dispatch(login({ username, password }));
  };

  const onSubmitEditing = () => {
    ref_password.current && ref_password.current.focus();
  };

  return (
    <LoginContainer>
      <View>
        <Input
          testID="email"
          placeholder={i18n.t("labels.email")}
          accessoryLeft={emailIcon}
          value={username}
          onChangeText={setUsername}
          onSubmitEditing={onSubmitEditing}
          onKeyPress={(e) => {
            if (Platform.OS === "web" && e.nativeEvent.key === "Tab") {
              e.preventDefault();
              onSubmitEditing();
            }
          }}
          underlineColorAndroid="transparent"
          {...loginInputProps}
        ></Input>

        <View style={{ marginVertical: 10 }}></View>

        <Input
          testID="password"
          ref={ref_password}
          placeholder={i18n.t("labels.password")}
          accessoryLeft={lockIcon}
          value={password}
          onChangeText={setPassword}
          secureTextEntry={true}
          underlineColorAndroid="transparent"
          onSubmitEditing={handleLogin}
          {...loginInputProps}
        ></Input>

        <View style={{ marginVertical: 10 }}></View>

        <Button
          onPress={handleLogin}
          loading={loading}
          testID="login-button"
          style={{
            backgroundColor: AUTH_SCREEN_BUTTON_BACKGROUND,
            borderWidth: 0,
          }}
        >
          {i18n.t("common.loginButton")}
        </Button>

        <Pressable
          style={{ marginTop: 15 }}
          onPress={() =>
            navigation.navigate("LoginFlow", { screen: "ForgotPassword" })
          }
        >
          <Text style={{ color: "white", fontSize: 16, textAlign: "center" }}>
            {i18n.t("screens.Login.forgotPassword")}
          </Text>
        </Pressable>
      </View>
    </LoginContainer>
  );
}
